import React,{useEffect,useState} from "react";
import "./HeroBanner.css";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const HeroBanner = ({
  Heading,
  subHeading,
  spanHeading="",
  nextLineSpanHeading,
  Paragraph,
  btnText,
  bgImg,
  bgVideo=false,
  btn=false,
  btnRef="/",
  socialLinks=false,
  serviceForm=false,
  bgEffect=false,
  heightAuto=false,
  smallHeading=false,
  sideLinks=true
}) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate()
    
      const formSubmitHandler = (e) => {
        e.preventDefault();
        setLoading(true);
        axios
          .post("/send-contact-form-main", {
            email: email,
            name:name,
            message:message,
            phoneNum:phone,
            formType: "Message genrated through Contact form",
          })
          .then((response) => {
            if (response.data.msg === "success") {
              setError(false);
              setSuccess("Message sent Successfully!");
              setLoading(false);
              setEmail("");
              navigate("/thank-you");
            } else if (response.data.msg === "fail") {
              setSuccess(false);
              setError("Failed to send message, try again by reloading the page.");
              setLoading(false);
              setEmail("");
            }
          });
      };
      
      const handlePhoneChange = (e) => {
        const numericValue = e.target.value.replace(/\D/g, ''); 
        const maxLength = 25;
    
    
        if (numericValue.length <= maxLength) {
          setPhone(numericValue);
        }
      };
      const handleNameChange = (e) => {
        const inputValue = e.target.value;
        const regex = /^[a-zA-Z\s]*$/;
    
        if (regex.test(inputValue) || inputValue === '') {
          setName(inputValue);
        }
      };

  const paragraphs = Paragraph.split('\n').map((paragraph, index) => <p key={index} className='hero-paragraph mx-auto' style={{width:"80%"}}>{paragraph}</p>);
  return (
    <>
    
      <Header/>
    
      <div
        className={`common_hero_section ${bgVideo && "bg-video"} ${heightAuto && "h-cus-auto"} mb-0`}
        style={{ backgroundImage: `url(${bgImg})`}}
          
      >
        <div className={`${bgEffect && "bg-effect"} h-100`}>
        { bgVideo && <video autoPlay loop muted>
          <source src="./images/backgroundVideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>}

        <div className="hero-container h-100  px-0"
        
        >
      <div className="wrapper d-flex flex-column pt-xl-3 pt-0">

        <div 
          className=" d-flex align-items-center py-5 my-auto container justify-content-center"
          >

          {sideLinks &&
          
          <div className="d-flex flex-column justify-content-center align-items-center gap-3">
            <h3 className="verticle-text" style={{color:"white"}}>SCROLL</h3>
            <div className="" style={{border:"1.5px solid white", width:"0" , height:"100px" }}></div>
          </div>
          }

          <div className={`gy-2 w-100 row ${serviceForm && "align-items-center "} `}>
            <div
              className={
                serviceForm
                  ? "col-md-6 d-none "
                  : "col-12 hero_content_wrapper px-3 w-100"
              }
            >
              <div className="hero-text-content w-100 text-center">
              <h5 className="hero-sub-heading">{subHeading}</h5>
              <h1 className={`hero-section-heading my-3 ${smallHeading && "hero-section-heading-small"} ${serviceForm && "text-lg-start text-center"} color-dark`}>
                {Heading}
                <span className="" style={{textTransform:"none"}}>{spanHeading}</span>
                {nextLineSpanHeading && <><br/> <span className="" style={{textTransform:"none"}}>{nextLineSpanHeading}</span></>}
              </h1>
              <p className="hero-paragraph mx-auto">{paragraphs}</p>
              {btn && <button className="genral-btn mt-4" onClick={()=>{navigate(btnRef)}}>{btnText}</button>}
              {socialLinks && (
                <div className="social-links py-2">
                 
                  {/* <div className="link-container d-flex align-items-center gap-2">
                    <img src="/images/icons/header-mail-icon.png" alt="icon" style={{borderRadius:"50%"}}/>
                    <p className="m-0 color-dark body-paragraph">betsycorreia@divitiisbc.com</p>
                  </div> */}
                 
                </div>
              )}
            </div>
            </div>
            {serviceForm && (
              <div className="col-md-6 py-4">
                <form className="service-form d-flex flex-column px-5 py-5" onSubmit={formSubmitHandler}>
                  <h3 className="body-heading" style={{ color: "white" }}>
                    Let’s get in touch!
                  </h3>
                  {/* <p
                    className="body-paragraph text-start"
                    style={{ color: "white" }}
                  >
                    Let’s discuss your project and find out what we can do
                  </p> */}
                  <input type="text" required placeholder="Your Full Name" value={name} onChange={handleNameChange} />
                  <input type="text" required placeholder="Your Email Address" value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                  <input type="text" required placeholder="Phone Number" value={phone} onChange={handlePhoneChange}/>
                  <input type="text" required placeholder="What I need help with" value={message} onChange={(e)=>{setMessage(e.target.value)}} />
                  <button className="genral-btn btn-dark mt-5" type="submit">Submit
                    {loading ? (
                                    <Spinner
                                        animation="border"
                                        role="status"
                                        style={{ color: "white" ,width:"15px",height:"15px",marginLeft:"10px"}}
                                    />
                                ) : (
                                success ? (
                                    <div>
                                    {setLoading(false)}
                                    {setSuccess(false)}
                                    </div>
                                ) : (
                                    error && (
                                    <div>
                                        {setLoading(false)}
                                        {alert(error)}
                                        {setError(false)}
                                    </div>
                                    )
                                )
                                )}
                  

                  </button>
                </form>
              </div>
            )}
          </div>
          {
          sideLinks &&
            <div className="d-flex flex-column justify-content-center align-items-center gap-3">
              <div className="icon-container d-flex flex-column align-items-center gap-3">
                <a 
                  href="https://www.facebook.com/meadowsequine/"
                  target="blank"  
                >
                  <img src="/images/icons/hero-fb-icon.svg" alt="icon"/>
                </a>

                <a 
                  href="https://www.instagram.com/meadows.equine/"
                  target="blank"  
                >
                  <img src="/images/icons/hero-insta-icon.svg" alt="icon"/>
                </a>
              </div>
              <div className="" style={{border:"1.5px solid white", width:"0" , height:"120px" }}></div>
            </div>
          }
        </div>
        </div>
        </div>
        </div>
      </div>

    </>
  );
};

export default HeroBanner; 